import { useNavigate } from "react-router-dom";
import { Hospital, Stethoscope, FileText, FlaskConical, Sparkles, Ambulance, Activity, Radiation } from "lucide-react";

const SERVICES = [
  { id: "find-hospitals", label: "Find Hospitals", icon: Hospital, color: "#2563EB", to: "/find-care" },
  { id: "consult-doctor", label: "Consult a Doctor", icon: Stethoscope, color: "#16A34A", to: "/doctors" },
  { id: "health-records", label: "Health Records", icon: FileText, color: "#EC4899", to: "/records" },
  { id: "vital-map", label: "Vital Map", icon: Activity, color: "#0EA5E9", to: "/vital-map" },
  { id: "lab-tests", label: "Book Lab Test", icon: FlaskConical, color: "#059669", to: "/lab-booking" },
  { id: "diagnostic-centres", label: "Diagnostic Centres", icon: Radiation, color: "#DB2777", to: "/diagnostic-centres" },
  { id: "trata-ai", label: "Dr Sanjeevani", icon: Sparkles, color: "#7C3AED", to: "/assistant" },
  { id: "emergency", label: "Emergency SOS", icon: Ambulance, color: "#DC2626", to: "/emergency" },
];

export default function CareHub() {
  const navigate = useNavigate();
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl md:text-3xl font-semibold">Care Hub</h1>
        <p className="text-muted-foreground mt-1">All your healthcare services in one place.</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {SERVICES.map((s) => {
          const Inner = (
            <>
              <div className="h-14 w-14 rounded-2xl flex items-center justify-center" style={{ backgroundColor: s.color + "1A" }}>
                <s.icon className="h-7 w-7" style={{ color: s.color }} />
              </div>
              <p className="mt-4 font-medium">{s.label}</p>
            </>
          );
          const cls = "rounded-3xl border border-border bg-card p-5 hover:shadow-md hover:-translate-y-0.5 transition-all cursor-pointer block";
          return s.href ? (
            <a key={s.id} href={s.href} className={cls} data-testid={`care-${s.id}`}>
              {Inner}
            </a>
          ) : (
            <button key={s.id} onClick={() => navigate(s.to)} className={cls + " text-left"} data-testid={`care-${s.id}`}>
              {Inner}
            </button>
          );
        })}
      </div>
    </div>
  );
}
